import React, { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { FormikProvider, useFormik, Field, Form } from "formik";
import * as Yup from "yup";
import Button from "../../../../customs/Button";
import Input from "../../../../customs/FormInput";
import { NotificationContext } from "../../../../providers/notification";
import apiCall from "../../../../utils/apiCall";
import { Card, styled } from "@mui/material";
import Header from "../../../../customs/Header";

const VerifyEmail = () => {
  const { showNotification } = useContext(NotificationContext);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
  });

  const handleVerifyEmail = async (values: { email: string }) => {
    try {
      verifyEmail(values.email);
    } catch (error: any) {
        console.log(error);
        
        showNotification({
            type: "error",
        message:
          error.message ||
          error?.response?.data?.title ||
          "There was an issue verifying the email. Please try again.",

        })
    }
  };
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: handleVerifyEmail,
  });

  const verifyApplicantEmail = async (email: string) => {
    return apiCall().post(
      `https://api.cipmnigeria.org/api/Applicant/VerifyEmail?email=${email}`,
    );
  };

  const { mutate: verifyEmail, isLoading } = useMutation(verifyApplicantEmail, {
    onSuccess: (response: any) => {
      showNotification({
        type: "success",
        message: response?.data?.message || "The email has been verified successfully.",
      });
      formik.resetForm();
    },
    onError: (error: any) => {
        console.log(error);
        
      showNotification({
        type: "error",
        message:
          error.response?.data?.Message ||
          error?.response?.data?.title ||
          "There was an issue verifying the email. Please try again.",
      });
    },
  });

  return (
    <section>
      <Header
        props={{
          firstName: "All",
          secondName: "Verify Email Address",
        }}
      />
      <StyledContainer>
        <h4>Verify Email Address</h4>
        <p>
          Enter the email address of the applicant who needs their account
          verified.
        </p>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Field
              name="email"
              type="email"
              as={Input}
              placeholder="user@example.com"
              
            />

            <StyledButton
              type="submit"
              text={isLoading ? "Verifying..." : "Verify"}
              disabled={isLoading}
            />
          </Form>
        </FormikProvider>
      </StyledContainer>
    </section>
  );
};

export default VerifyEmail;

const StyledButton = styled(Button)`
  padding-block: 1rem;
  padding-inline: 2rem;
`;
const StyledContainer = styled("div")`
  margin-block: 3.8rem;
  margin-inline: 3.5rem;
`;
